module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_1star@3x.66fc7388.png";